







































import Vue from 'vue';
import Component from 'vue-class-component';
import {TimelineModel} from '@/models/timeline.model';
import TimelineItem from '@/components/Challenges/tabs/timeline/TimelineItem.vue';
import TimelineInteraction from '@/components/Challenges/tabs/timeline/TimelineInteraction.vue';
import {
  acceptedModule,
  acceptedState,
  authModule,
  challengeModule,
  timelineModule,
  timelineState,
  userModule
} from '@/utils/store-acessor';
import {ChallengeModel} from '@/models/challenge.model';
import {Watch} from 'vue-property-decorator';
import moment from 'moment-timezone';
import YouAreHere from '@/components/Challenges/tabs/timeline/YouAreHere.vue';

@Component({
  components: {YouAreHere, TimelineItem, TimelineInteraction}
})
export default class ChallengerDetailTimeline extends Vue {
  @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel;
  @timelineModule.Getter('timeline') timeline!: TimelineModel[];
  @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
  @acceptedModule.Getter('acceptedChallenges') acceptedChallenges!: ChallengeModel[];
  @acceptedModule.Getter('userHasAccepted') userHasAccepted!: (challengeId: number) => boolean;
  @userModule.Getter('canAcceptChallenges') canAccept!: boolean;
  @userModule.Getter('timezone') timezone!: string;

  async mounted() {
    if (this.challenge?.id) {
      await timelineState.fetchTimeline(this.challenge.id);
    }
  }

  @Watch('canAccept', {immediate: true, deep: true})
  async listenCanAcceptChallenge(v: boolean) {
    if (v) {
      await acceptedState.fetchAcceptedChallenges({params: {page: 1}});
      if (this.challenge.id) {
        await timelineState.fetchTimeline(this.challenge.id);
      }
    }
  }

  formatDate(date: string): string {
    return moment(date)
            .tz(this.timezone)
            .format('MMM. D YYYY, HH:mm a')
            .toString()
  }

  showYouAreHere(currentIndex: number, nextIndex: number): boolean {
    const currentItem = this.timeline[currentIndex];
    const nextItem = this.timeline[nextIndex];
    if (currentItem && nextItem) {

      const now = moment().tz(this.timezone);
      const nextStart = moment(nextItem.start_at).tz(this.timezone);
      const currentStart = moment(currentItem.start_at).tz(this.timezone);

      if (now.isBefore(nextStart) && now.isSameOrAfter(currentStart)) {
        return true
      }
    }
    return false;
  }

}
